<div *ngIf="isMobile" class="w-full bg-white shadow-sm border-b border-gray-200">

  <div class="flex h-[5rem]  items-center  justify-between p-4 cursor-pointer"
    (click)="showMobileSteps = !showMobileSteps" (keydown.enter)="showMobileSteps = !showMobileSteps">

    <div class="flex flex-row items-center justify-center gap-[1rem]">
      
      <NiFormIcon icon="arrowLeft" iconClass="!w-[24px] !w-[24px] cursor-pointer" (click)="navigateBack(); $event.stopPropagation()"
        (keydown.enter)="navigateBack(); $event.stopPropagation()" />

      <div class="flex flex-row gap-[16px] items-center justify-center">
        <div class="flex items-center justify-center w-[2.5rem] h-[2.5rem] rounded-full  bg-primary-500 text-white">
          {{currentStepIndex + 1}}
        </div>
        <div>
          <div class="text-gray-700 text-[12px] font-archivo">
            Step {{ currentStepIndex + 1 }}/{{ stepperData.length }}
          </div>
          <div class="text-gray-700 text-[18px] font-archivo font-semibold">
            {{ stepperData[currentStepIndex].title }}
          </div>
        </div>
      </div>
    </div>



    <NiFormIcon icon="ArrowDropDown" [class]="'transition-transform ' + (showMobileSteps ? 'rotate-180' : '')"
      iconClass="!w-6 !h-6"></NiFormIcon>
  </div>

  <div class="w-full h-1 bg-gray-200">
    <div class="h-1 bg-primary-500 transition-all duration-300" [style.width.%]="progressPercent"></div>
  </div>

  <div *ngIf="showMobileSteps" class="p-4 border-t border-gray-200">
    <ng-container *ngTemplateOutlet="desktopStepper"></ng-container>
  </div>
</div>


<div *ngIf="!isMobile">
  <ng-container *ngTemplateOutlet="desktopStepper"></ng-container>
</div>


<ng-template #desktopStepper>
  <div class="flex flex-col gap-2 bg-transparent  rounded-md">
    <div *ngFor="let step of stepperData; let index = index" (click)="handleNavigation(step, index)"
      (keydown.enter)="handleNavigation(step, index)"
      [class]="'flex flex-col items-start relative transition-all duration-200 rounded-sm   ' + (disableNavigation ? 'cursor-default' : 'cursor-pointer hover:bg-gray-100') + ' ' + (step.status !== 'completed' ? 'pt-[0.188rem]' : 'pt-[0.188rem]')">
      <div class="flex flex-row items-center  gap-[0.5rem] relative">
        <div #stepRef class="flex items-center justify-center w-[2.5rem] h-[2.5rem] rounded-full border-2 " [ngClass]="[
          getStatusColors(step.status).bg,
          getStatusColors(step.status).border,
          getStatusColors(step.status).text
        ]">
          @if (step.status === 'completed') {
          <NiFormIcon icon="stepperCheck" iconClass="!w-[1rem] !h-[1rem]'"></NiFormIcon>
          } @else {
          <span class="text-[1.125rem] font-archivo">{{ index + 1 }}</span>
          }
        </div>
        <div class="flex flex-col justify-center">
          <span class="text-[1.125rem] text-gray-700 font-archivo">
            {{ step.title }}
          </span>
  
          <span *ngIf="step.status === 'completed'" class="text-[1rem] text-success-500 font-archivo">Completed</span>
        </div>
       
      </div>

     <div class="w-[40px] flex items-center justify-center">
      <div *ngIf="index !== stepperData.length - 1" class="w-[0.125rem]" [ngClass]="getStatusColors(step.status).line"
      [ngStyle]="{
      height: step.status === 'completed'? '1.50rem' : '1.50rem',
      marginTop: step.status === 'completed' ?  '0.188rem' : '0.188rem'
    }"></div>
    </div>
    </div>
  </div>
</ng-template>